import axiosAuth from "../../axiosAuth";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface mutateProps {
  projectId: string;
  taskId: string;
  data: any
}

const mutateAddTaskAttachment = async ({projectId, taskId, data}: mutateProps) => {
  return await axiosAuth.post(`${PROJECT_API}/${projectId}/tasks/${taskId}/attachments`, data, { headers: {
    "Content-Type": "multipart/form-data",
  } });
};

const useAddTaskAttachmentMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateAddTaskAttachment,
    ...queryParams,
  });

export default useAddTaskAttachmentMutation;
